import { Component, ViewEncapsulation, HostListener, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { StorageService } from '../../services/storage.service';
import { RoutePath } from '../../enum/common-enum';

import { SupportTicketsService } from '../../../components/support-tickets/support-tickets.service';
import { GetAllSupportTicketsRequest } from '../../../components/support-tickets/support-tickets.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  public iconSidebar;
  public menuItems: Menu[];
  public url: any;
  public fileurl: any;

  // For Horizontal Menu
  public margin: any = 0;
  public width: any = window.innerWidth;
  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;

  constructor(
    private router: Router,
    public navServices: NavService,
    public layoutService: LayoutService,
    public storageService: StorageService,
    public layout: LayoutService,
    private supportTicketsService: SupportTicketsService
  ) {
    const isRegisterId =  this.storageService.retrieve('REGISTER_ID')
    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems;
      const whatsappPaths:any = [
      RoutePath.WhatsappCampaign,
      RoutePath.WhatsappReport,
      RoutePath.Inbox
     ];
     this.menuItems = this.menuItems.filter(item =>
     isRegisterId ? whatsappPaths.includes(item.path) : !whatsappPaths.includes(item.path)
     );
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.menuItems.filter(items => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) { return false; }
            items.children.filter(subItems => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) { return false; }
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
            });
          });
        }
      });
    });

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = event.target.innerWidth - 500;
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  // Active Nave state
  setNavActive(item) {
    this.storageService.isInboxTabActive = item?.path == RoutePath.Inbox
    this.menuItems.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  // Click Toggle menu
  toggletNavActive(item,) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }


  // For Horizontal Menu
  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3051) {
      this.margin = -3464;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }

  ngOnInit(): void {
    this.loadSupportTicketCount();
    interval(10 * 60 * 1000) // 10 minutes interval
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.loadSupportTicketCount();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadSupportTicketCount() {
    const request = new GetAllSupportTicketsRequest();
    request.page = 1;
    request.pageSize = 1;
    this.supportTicketsService.getAll(request).subscribe({
      next: (res) => {
        if (res?.isSuccess && res.response) {
          const count = res.response?.unreadCount ?? 0;
          this.navServices.updateMenuItemUnreadCount('/support-tickets', count);
        }
      },
      error: () => {}
    });
  }

}
